var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import CustomCard from '../CustomCard';
import { Grid } from 'material-ui';
import TextField from 'material-ui/TextField/TextField';
import Button from 'material-ui/Button/Button';
import { CustomCardHeader } from '../CustomCardHeader';
import CardContent from 'material-ui/Card/CardContent';
import { connect } from 'react-redux';
import { sendUpdateMessage } from '../../websocket';
var TelegramSender = /** @class */ (function (_super) {
    __extends(TelegramSender, _super);
    function TelegramSender() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            ivuTelegramMessage: '',
            rcTelegramMessage: '',
        };
        _this.handleIvuTelegramMessageChange = function (event) {
            _this.setState({
                ivuTelegramMessage: event.target.value,
            });
        };
        _this.handleRcTelegramMessageChange = function (event) {
            _this.setState({
                rcTelegramMessage: event.target.value,
            });
        };
        _this.sendIvuTelegramMessage = function () {
            var ivuTelegramMessage = _this.state.ivuTelegramMessage;
            if (!ivuTelegramMessage) {
                return;
            }
            _this.props.sendUpdateMessage('ivuTelegram', { telegram: ivuTelegramMessage });
        };
        _this.sendRcTelegramMessage = function () {
            var rcTelegramMessage = _this.state.rcTelegramMessage;
            if (!rcTelegramMessage) {
                return;
            }
            _this.props.sendUpdateMessage('rcTelegram', { telegram: rcTelegramMessage });
        };
        return _this;
    }
    TelegramSender.prototype.render = function () {
        return (React.createElement(CustomCard, null,
            React.createElement(CustomCardHeader, null, "Send Telegram"),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true, lg: true },
                        React.createElement(TextField, { fullWidth: true, label: "IVU telegram", value: this.state.ivuTelegramMessage, onChange: this.handleIvuTelegramMessageChange, margin: "normal" })),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { variant: "raised", color: 'primary', onClick: this.sendIvuTelegramMessage }, "Send"))),
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true, lg: true },
                        React.createElement(TextField, { fullWidth: true, multiline: true, label: "RC telegram", value: this.state.rcTelegramMessage, onChange: this.handleRcTelegramMessageChange, margin: "normal" })),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { variant: "raised", color: 'primary', onClick: this.sendRcTelegramMessage }, "Send"))))));
    };
    return TelegramSender;
}(React.PureComponent));
export default connect(undefined, { sendUpdateMessage: sendUpdateMessage })(TelegramSender);



//////////////////
// WEBPACK FOOTER
// ./src/components/TelegramSender/index.tsx
// module id = 1824
// module chunks = 0